module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "table-row user-list-item clickable"
  }, [(_vm.showCheckbox) ? _c('div', {
    staticClass: "table-col table-col-collapsed",
    class: {
      'table-modal-rd': _vm.listCarousel
    }
  }, [_c('div', {
    staticClass: "checkbox-inline contact-list-item-checkbox-item",
    on: {
      "click": function($event) {
        return _vm.checkboxSelectUser(_vm.user)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.selected),
      expression: "user.selected"
    }],
    attrs: {
      "type": "checkbox",
      "id": _vm.user_index
    },
    domProps: {
      "checked": Array.isArray(_vm.user.selected) ? _vm._i(_vm.user.selected, null) > -1 : (_vm.user.selected)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.user.selected,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.user, "selected", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.user, "selected", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.user, "selected", $$c)
        }
      }
    }
  }), _c('label', {
    attrs: {
      "for": _vm.user_index
    }
  }, [_vm._v(" ")])])]) : _vm._e(), _c('div', {
    staticClass: "table-col table-col-150",
    class: {
      'table-modal-rd': _vm.listCarousel
    }
  }, [_c('div', {
    staticClass: "identity"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.user.custom_field_value))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7c71b25a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/users/list_copy.vue
// module id = 1176
// module chunks = 1